module.exports = __webpack_public_path__ + "img/flgy.b7dbd4f6.png";